(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collectionbanner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let arrow = document.querySelector('.category-page__navigation-icon');
  if (arrow) {
    arrow.addEventListener('click', function(event) {
      event.preventDefault();
      let pathParts = window.location.pathname.split('/');
      pathParts.pop(); // Remove last segment
      let newPath = pathParts.join('/') || '/';
      window.location.href = newPath;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["communitysection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    const joinText = document.querySelector('.community-section__title');
    const dropdownArrow = document.querySelector('.community-section__icon');

    if (joinText && dropdownArrow) {
      joinText.addEventListener('click', () => {
        dropdownArrow.classList.toggle('rotate');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homequiz"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const startButton = document.querySelector('.content__cta');
    if (startButton) {
      startButton.addEventListener('click', function() {
        // Add your quiz start logic here
        console.log('Quiz started!');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["userreviewproduct"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const ratingInputs = document.querySelectorAll('.ratingbar input[type="radio"]');
    ratingInputs.forEach(input => {
      input.addEventListener('change', function() {
        console.log('Rating changed to: ' + this.value);
        // You can add more functionality here, like sending the rating to a server
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
